export const tr = {
    'robot-ne-smozhet-vvesti':
        'Gerçek bir kişi olduğunuzu doğrulamak için lütfen güvenlik sembollerini girin. Karakter sorgusu, verilerinizin gizliliğini sağlamak amacıyla düzenli olarak yapılır.',
    send: 'Gönder',
    'vvedite-simvoly-s-kartinki': 'Karakterleri girin'
};
